var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsappIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1415_52539)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4 7.45C22.15 5.2 19.15 4 16 4C9.4 4 4 9.4 4 16C4 18.1 4.60001 20.2 5.65001 22L4 28L10.3 26.35C12.1 27.25 14.05 27.85 16 27.85C22.6 27.85 28 22.45 28 15.85C28 12.7 26.65 9.7 24.4 7.45ZM16 25.9C14.2 25.9 12.4 25.45 10.9 24.55L10.6 24.4L6.84999 25.45L7.90001 21.85L7.59999 21.4C6.54999 19.75 6.09999 17.95 6.09999 16.15C6.09999 10.75 10.6 6.25 16 6.25C18.7 6.25 21.1 7.3 23.05 9.1C25 11.05 25.9 13.45 25.9 16.15C25.9 21.4 21.55 25.9 16 25.9ZM21.4 18.4C21.1 18.25 19.6 17.5 19.3 17.5C19 17.35 18.85 17.35 18.7 17.65C18.55 17.95 17.95 18.55 17.8 18.85C17.65 19 17.5 19 17.2 19C16.9 18.85 16 18.55 14.8 17.5C13.9 16.75 13.3 15.7 13.15 15.4C13 15.1 13.15 14.95 13.3 14.8C13.45 14.65 13.6 14.5 13.75 14.35C13.9 14.2 13.9 14.05 14.05 13.9C14.2 13.75 14.05 13.6 14.05 13.45C14.05 13.3 13.45 11.8 13.15 11.2C13 10.75 12.7 10.75 12.55 10.75C12.4 10.75 12.25 10.75 11.95 10.75C11.8 10.75 11.5 10.75 11.2 11.05C10.9 11.35 10.15 12.1 10.15 13.6C10.15 15.1 11.2 16.45 11.35 16.75C11.5 16.9 13.45 20.05 16.45 21.25C19 22.3 19.45 22 20.05 22C20.65 22 21.85 21.25 22 20.65C22.3 19.9 22.3 19.3 22.15 19.3C22 18.55 21.7 18.55 21.4 18.4Z",
    fill: "#60D66A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1415_52539"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsappIcon.454f710f.svg";
export { ForwardRef as ReactComponent };